import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import OrderCancel from "src/components/footer/confirmation/orderCancel";
import { closeOrderCancel } from "src/redux/reducers/modals";
import { useAppSelector, useAppDispatch } from "../../hooks/redux";
import OutsideClickHandler from "react-outside-click-handler";
const CancelOrder = () => {
    const dispatch = useAppDispatch();
    const cancelOrderData = useAppSelector((state) => {
        return state.modals.orderCancelData;
    });
    return (_jsx(_Fragment, { children: cancelOrderData && (_jsx(OutsideClickHandler, Object.assign({ onOutsideClick: () => {
                dispatch(closeOrderCancel());
            } }, { children: _jsx(OrderCancel, { cancelData: cancelOrderData, hideShowCancelOrderModal: true, callBackForDeleteOrder: () => {
                    dispatch(closeOrderCancel());
                } }) }))) }));
};
export default CancelOrder;
